import { render, staticRenderFns } from "./setClass.vue?vue&type=template&id=07d73465&scoped=true&"
import script from "./setClass.vue?vue&type=script&lang=js&"
export * from "./setClass.vue?vue&type=script&lang=js&"
import style0 from "./setClass.vue?vue&type=style&index=0&id=07d73465&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d73465",
  null
  
)

export default component.exports